import React from "react";
import Oryzaleisure from "./oryzaleisure";

export default function Pettipettimain() {
  return (
    <div>
      <Oryzaleisure />
    </div>
  );
}
